export const applicationTypes = {
    APPLICATION_SELECT: 'APPLICATION_SELECT',
    APPLICATION_INFO_REQUEST: 'APPLICATION_INFO_REQUEST',
    APPLICATION_INFO_SUCCESS: 'APPLICATION_INFO_SUCCESS',
    APPLICATION_INFO_FAILURE: 'APPLICATION_INFO_FAILURE'
}